<script setup lang="ts">
const ages = Array(18)
  .fill(0)
  .map((x, index) => ({ age: index }))

const searchStore = useSearchv2Store()

const isOpen = ref(false)

const { cloned: adults } = useCloned(
  searchStore.searchParameters.parameters.value.persons.adults
)

const { cloned: children } = useCloned(
  searchStore.searchParameters.parameters.value.persons.children
)

const UpdateStoreValues = () => {
  searchStore.setAdults(adults.value)
  searchStore.setChildren([...children.value])
  searchStore.setSearchPartyCookie()
  emits('apply-search')
  isOpen.value = false
}

const handleClose = () => {
  adults.value = useCloned(
    searchStore.searchParameters.parameters.value.persons.adults
  ).cloned.value

  children.value = useCloned(
    searchStore.searchParameters.parameters.value.persons.children
  ).cloned.value
  searchStore.setSearchPartyCookie()
  isOpen.value = false
}

const emits = defineEmits(['apply-search'])
</script>

<template>
  <slot name="button" :open="() => (isOpen = true)">
    <VButton
      variant="unstyled"
      class="w-full bg-brand-white border border-brand-secondary-400 hover:bg-brand-gray-100 px-2.5 py-2.5 shadow-custom flex flex-row items-center justify-between text-brand-secondary-500"
      @click="isOpen = true"
    >
      <span>{{
        searchStore.getFormattedPersons(
          searchStore.getNumberOfAdults,
          searchStore.getNumberOfChildren
        )
      }}</span>
      <NuxtImg height="20" width="20" src="icons/misc/people.svg" />
    </VButton>
  </slot>
  <ResponsiveDialogWrapper
    :open="isOpen"
    :modal-props="{
      whiteCloseButton: true,
      closeOnOutsideClick: true,
      wide: true,
    }"
    :drawer-props="{
      direction: 'top',
      showButtons: true,
      whiteCloseButton: true,
    }"
    @close="handleClose"
  >
    <template #header>
      <div class="p-md bg-brand-secondary-900">
        <h4 class="font-h4 text-brand-white">
          {{ $t('person-picker.edit-persons') }}
        </h4>
      </div>
    </template>

    <div class="max-w-full min-h-[35rem] md:p-md">
      <div class="text-brand-secondary-400">
        <div class="flex justify-between items-center border-b py-sm">
          <p class="text-brand-secondary-800">
            {{ $t('person-picker.adults') }}
          </p>
          <FormNumberPicker v-model="adults" :min-value="1" />
        </div>
        <div class="flex justify-between items-center border-b py-sm">
          <p class="text-brand-secondary-800">
            {{ $t('person-picker.children') }}
          </p>
          <FormNumberPicker
            v-model="children.length"
            :min-value="0"
            @before-increment="children.push({ age: 12 })"
            @before-decrement="children.pop()"
          />
        </div>
      </div>
      <div class="children-section flex flex-col">
        <div
          v-for="(age, index) in children"
          :key="index"
          class="flex justify-between items-center gap-10 border-t-2 first-of-type:border-t-0 last-of-type:border-b-2 py-sm border-brand-gray-100"
        >
          <p class="text-brand-secondary-800">
            {{ $t('person-picker.age-of-child') }}
          </p>
          <div>
            <FormDropdown
              :null-value="age.age.toString()"
              :items="ages"
              value="age"
              @on-change="(val: {age:number}) => children[index] = val"
            />
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="flex gap-4 w-full p-sm">
        <VButton
          class="!w-full justify-center"
          variant="alternative"
          @click="handleClose"
          >{{ $t('common.cancel') }}</VButton
        >
        <VButton class="!w-full justify-center" @click="UpdateStoreValues">{{
          $t('common.apply')
        }}</VButton>
      </div>
    </template>
  </ResponsiveDialogWrapper>
</template>
